export default __webpack_public_path__ + "static/config-generators-460ba920939258e4c3fe796a79368422.png";